// import { useEffect, useState, useCallback } from "react";
// import ProductsTable from "./ProductsTable";
// import Spinner from "../../components/Spinner";
// import {
//   fetchProducts,
//   approveProduct,
//   rejectProduct,
// } from "./adminProductsAPI";
// import { useAuth } from "../../contexts/AuthContext";
// export default function AdminProducts() {
//   const { auth } = useAuth();
//   const token = auth?.token;
//   const [products, setProducts] = useState([]);
//   const [pageInfo, setPageInfo] = useState({
//     number: 0,
//     size: 20,
//     totalPages: 0,
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const loadProducts = useCallback(
//     async (page = 0, size = pageInfo.size) => {
//       if (!token) {
//         setLoading(false);
//         setError("Authentication required");
//         return;
//       }
//       try {
//         setLoading(true);
//         const data = await fetchProducts(token, page, size);
//         setProducts(data.content || []);
//         setPageInfo({
//           number: data.pageNumber,
//           size: data.pageSize,
//           totalPages: data.totalPages,
//         });
//         setError("");
//       } catch (err) {
//         console.error("Failed to load products:", err);
//         setError(err?.response?.data?.message || "Failed to load products");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [token, pageInfo.size],
//   );
//   useEffect(() => {
//     if (token) {
//       loadProducts(0);
//     }
//   }, [token, loadProducts]);
//   /* ---------------- APPROVE ---------------- */ const handleApprove = async (
//     id,
//   ) => {
//     if (!token) {
//       setError("Authentication required");
//       return;
//     }
//     try {
//       await approveProduct(token, id);
//       await loadProducts(pageInfo.number);
//     } catch (err) {
//       console.error("Failed to approve product:", err);
//       setError(err?.response?.data?.message || "Failed to approve product");
//     }
//   };
//   /* ---------------- REJECT ---------------- */ const handleReject = async (
//     id,
//     reason,
//   ) => {
//     if (!token) {
//       setError("Authentication required");
//       return;
//     }
//     try {
//       await rejectProduct(token, id, reason);
//       await loadProducts(pageInfo.number);
//     } catch (err) {
//       console.error("Failed to reject product:", err);
//       setError(err?.response?.data?.message || "Failed to reject product");
//     }
//   };
//   /* ---------------- LOADING ---------------- */ if (loading) {
//     return <Spinner />;
//   }
//   if (error) {
//     return <div className="alert alert-danger"> {error} </div>;
//   }
//   return (
//     <div>
//       {" "}
//       <h2 className="mb-4"> Product Moderation </h2>{" "}
//       <ProductsTable
//         products={products}
//         onApprove={handleApprove}
//         onReject={handleReject}
//       />{" "}
//       {/* Pagination */}{" "}
//       <div className="d-flex justify-content-between align-items-center mt-4">
//         {" "}
//         <button
//           type="button"
//           className="btn btn-outline-primary"
//           disabled={pageInfo.number === 0 || loading}
//           onClick={() => loadProducts(pageInfo.number - 1)}
//         >
//           {" "}
//           ← Previous{" "}
//         </button>{" "}
//         <span>
//           {" "}
//           Page {pageInfo.number + 1} of {pageInfo.totalPages}{" "}
//         </span>{" "}
//         <button
//           type="button"
//           className="btn btn-outline-primary"
//           disabled={pageInfo.number + 1 >= pageInfo.totalPages || loading}
//           onClick={() => loadProducts(pageInfo.number + 1)}
//         >
//           {" "}
//           Next →{" "}
//         </button>{" "}
//       </div>{" "}
//     </div>
//   );
// }

import { useEffect, useState, useCallback } from "react";
import ProductsTable from "./ProductsTable";
import Spinner from "../../components/Spinner";
import {
  fetchProducts,
  approveProduct,
  rejectProduct,
} from "./adminProductsAPI";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminProducts() {
  const { auth } = useAuth();

  const token = auth?.token;

  const [products, setProducts] = useState([]);

  const [pageInfo, setPageInfo] = useState({
    number: 0,
    size: 20,
    totalPages: 0,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadProducts = useCallback(
    async (page = 0, size = pageInfo.size) => {
      if (!token) {
        console.log(token);
        setLoading(false);
        setError("Authentication required");
        return;
      }

      try {
        setLoading(true);
        setError("");

        console.log(token);
        console.log("Loading products with token:", !!token);

        const data = await fetchProducts(token, page, size);

        console.log("Products response:", data);

        setProducts(data.content || []);

        setPageInfo({
          number: data.pageNumber ?? 0,
          size: data.pageSize ?? size,
          totalPages: data.totalPages ?? 0,
        });
      } catch (err) {
        console.error("Failed to load products:", err);

        console.error("Status:", err.response?.status);

        console.error("Response:", err.response?.data);

        setError(err.response?.data?.message || "Failed to load products");
      } finally {
        setLoading(false);
      }
    },
    [token, pageInfo.size],
  );

  useEffect(() => {
    if (token) {
      loadProducts(0);
    }
  }, [token, loadProducts]);

  const handleApprove = async (id) => {
    if (!token) {
      setError("Authentication required");
      return;
    }

    try {
      await approveProduct(token, id);

      await loadProducts(pageInfo.number);
    } catch (err) {
      console.error("Failed to approve product:", err);

      setError(err.response?.data?.message || "Failed to approve product");
    }
  };

  const handleReject = async (id, reason) => {
    if (!token) {
      setError("Authentication required");
      return;
    }

    try {
      await rejectProduct(token, id, reason);

      await loadProducts(pageInfo.number);
    } catch (err) {
      console.error("Failed to reject product:", err);

      setError(err.response?.data?.message || "Failed to reject product");
    }
  };

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div>
      <h3 className="mb-4">Product Moderation</h3>

      <ProductsTable
        products={products}
        onApprove={handleApprove}
        onReject={handleReject}
      />

      <div className="d-flex justify-content-between align-items-center mt-4">
        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={pageInfo.number === 0 || loading}
          onClick={() => loadProducts(pageInfo.number - 1)}
        >
          ← Previous
        </button>

        <span>
          Page {pageInfo.number + 1} of {pageInfo.totalPages}
        </span>

        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={pageInfo.number + 1 >= pageInfo.totalPages || loading}
          onClick={() => loadProducts(pageInfo.number + 1)}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
